var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_1473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 12,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66457 1.05093C4.20467 1.4984 4.20467 2.22388 4.66457 2.67135L11.6828 9.49985L4.66457 16.3284C4.20467 16.7758 4.20467 17.5013 4.66457 17.9488C5.12447 18.3962 5.87011 18.3962 6.33001 17.9488L15.0137 9.49985L6.33001 1.05093C5.87011 0.603466 5.12447 0.603466 4.66457 1.05093Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_1473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.500488,
    y: 0.331787,
    width: 18.3326,
    height: 18.3329,
    fill: "#B2B2B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGrey);
export default __webpack_public_path__ + "static/media/right_grey.adfcc5bee9348848102a5fc95c5b44ae.svg";
export { ForwardRef as ReactComponent };